import dogLeftSideImage from '../../ImageDiagnosis/diagnosisImages/assets/dog-leftside.png';
import dogRightSideImage from '../../ImageDiagnosis/diagnosisImages/assets/dog-rightside.png';
import {
  myofascialPain,
  cancer,
  pawOrNailInjury,
  trauma,
  cruciateLigamentInjury,
  orthopedicOther,
  orthopedicOa,
  degenerativeDiscDisease,
  intraAbdominalPathology,
  luxatingPatellas
} from '../painConditions';
import { DxImageWithPointsAndConditions } from '../imageDxTypes';

// dogDxImages is the list of image (right and left sides) with all points for the dog pain diagnosis.
export const dogPainDxImages: DxImageWithPointsAndConditions[] = [
  {
    name: 'Right Side',
    imageUrl: dogRightSideImage,
    points: [
      {
        label: 'Neck',
        name: 'neck',
        x: 426,
        y: 140,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, cancer, myofascialPain]
      },
      {
        label: 'Thoracic',
        name: 'thoracic',
        x: 346,
        y: 169,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, cancer, myofascialPain]
      },
      {
        label: 'Lumbar',
        name: 'lumbar',
        x: 267,
        y: 174,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, cancer, myofascialPain]
      },

      {
        label: 'L-S',
        name: 'l_s',
        x: 193,
        y: 178,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, cancer, myofascialPain]
      },
      {
        label: 'Right Hip',
        name: 'right_hip',
        x: 156,
        y: 216,
        conditions: [orthopedicOa, orthopedicOther, trauma, cancer, myofascialPain]
      },
      {
        label: 'Right Knee',
        name: 'right_knee',
        x: 166,
        y: 312,
        conditions: [
          orthopedicOa,
          orthopedicOther,
          cruciateLigamentInjury,
          luxatingPatellas,
          trauma,
          cancer,
          myofascialPain
        ]
      },
      {
        label: 'Right Tarsus',
        name: 'right_tarsus',
        x: 60,
        y: 399,
        conditions: [orthopedicOa, orthopedicOther, trauma, cancer, myofascialPain]
      },
      {
        label: 'Right Back Toes',
        name: 'right_back_toes',
        x: 97,
        y: 482,
        conditions: [orthopedicOa, orthopedicOther, pawOrNailInjury, trauma, cancer, myofascialPain]
      },
      {
        label: 'Right Front Toes',
        name: 'right_front_toes',
        x: 465,
        y: 482,
        conditions: [orthopedicOa, orthopedicOther, pawOrNailInjury, trauma, cancer, myofascialPain]
      },
      {
        label: 'Right Carpus',
        name: 'right_carpus',
        x: 439,
        y: 427,
        conditions: [orthopedicOa, orthopedicOther, trauma, cancer, myofascialPain]
      },
      {
        label: 'Right Elbow',
        name: 'right_elbow',
        x: 413,
        y: 319,
        conditions: [orthopedicOa, orthopedicOther, trauma, cancer, myofascialPain]
      },
      {
        label: 'Right Shoulder',
        name: 'right_shoulder',
        x: 470,
        y: 221,
        conditions: [orthopedicOa, orthopedicOther, trauma, cancer, myofascialPain]
      },
      {
        label: 'Abdominal',
        name: 'abdominal',
        x: 287,
        y: 262,
        conditions: [intraAbdominalPathology, trauma, cancer]
      }
    ]
  },
  {
    name: 'Left Side',
    imageUrl: dogLeftSideImage,
    points: [
      {
        label: 'Neck',
        name: 'neck',
        x: 241,
        y: 140,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, cancer, myofascialPain]
      },
      {
        label: 'Thoracic',
        name: 'thoracic',
        x: 321,
        y: 169,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, cancer, myofascialPain]
      },
      {
        label: 'Lumbar',
        name: 'lumbar',
        x: 400,
        y: 174,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, cancer, myofascialPain]
      },

      {
        label: 'L-S',
        name: 'l_s',
        x: 474,
        y: 178,
        conditions: [orthopedicOa, orthopedicOther, degenerativeDiscDisease, trauma, cancer, myofascialPain]
      },
      {
        label: 'Left Hip',
        name: 'left_hip',
        x: 511,
        y: 216,
        conditions: [orthopedicOa, orthopedicOther, trauma, cancer, myofascialPain]
      },
      {
        label: 'Left Knee',
        name: 'left_knee',
        x: 501,
        y: 312,
        conditions: [
          orthopedicOa,
          orthopedicOther,
          cruciateLigamentInjury,
          luxatingPatellas,
          trauma,
          cancer,
          myofascialPain
        ]
      },
      {
        label: 'Left Tarsus',
        name: 'left_tarsus',
        x: 607,
        y: 399,
        conditions: [orthopedicOa, orthopedicOther, trauma, cancer, myofascialPain]
      },
      {
        label: 'Left Back Toes',
        name: 'left_back_toes',
        x: 570,
        y: 482,
        conditions: [orthopedicOa, orthopedicOther, pawOrNailInjury, trauma, cancer, myofascialPain]
      },
      {
        label: 'Left Front Toes',
        name: 'left_front_toes',
        x: 202,
        y: 482,
        conditions: [orthopedicOa, orthopedicOther, pawOrNailInjury, trauma, cancer, myofascialPain]
      },
      {
        label: 'Left Carpus',
        name: 'left_carpus',
        x: 228,
        y: 427,
        conditions: [orthopedicOa, orthopedicOther, trauma, cancer, myofascialPain]
      },
      {
        label: 'Left Elbow',
        name: 'left_elbow',
        x: 254,
        y: 319,
        conditions: [orthopedicOa, orthopedicOther, trauma, cancer, myofascialPain]
      },
      {
        label: 'Left Shoulder',
        name: 'left_shoulder',
        x: 197,
        y: 221,
        conditions: [orthopedicOa, orthopedicOther, trauma, cancer, myofascialPain]
      },
      {
        label: 'Abdominal',
        name: 'abdominal',
        x: 380,
        y: 262,
        conditions: [intraAbdominalPathology, trauma, cancer]
      }
    ]
  }
];
